import React from 'react';
import PropTypes from 'prop-types';

import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function InsightsIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="174 16 32 21"
      role="presentation"
    >
      <G fill={color} fillRule="evenodd">
        <Path
          d="M193.1 26.437c0 1.784-1.36 3.235-3.03 3.235-1.672 0-3.03-1.45-3.03-3.235 0-1.783
          1.358-3.235 3.03-3.235 1.67 0 3.03 1.452 3.03 3.235m-6.88 0c0 2.276 1.73 4.12 3.86
          4.12 2.132 0 3.86-1.844 3.86-4.12 0-2.275-1.728-4.12-3.86-4.12-2.13 0-3.86 1.845-3.86
          4.12"
        />
        <Path
          d="M200.013 31.026c-.91.824-1.786 1.5-2.604 2.078 1.44-1.796 2.303-4.12 2.303-6.667
            0-2.903-1.13-5.535-2.95-7.405 1.153.69 2.374 1.6 3.642 2.793 2.05 1.93 3.422 3.9 3.883
            4.588-.52.676-2.097 2.657-4.275 4.613zm-24.29-4.59c.738-.97 3.527-4.464 7.202-6.9-1.544
            1.834-2.49 4.244-2.49 6.9 0 2.744 1.015 5.254 2.663
            7.1-1.014-.653-2.097-1.465-3.226-2.498-2.132-1.944-3.64-3.9-4.148-4.6zm23.16 0c0
            4.762-3.33 8.71-7.627 9.325-.035
            0-.07.014-.104.014h-.034c-.23.024-.438.05-.646.06h-.023c-.058 0-.127
            0-.185.013h-.207c-4.863 0-8.815-4.22-8.815-9.41 0-5.018 3.7-9.127
            8.33-9.397h.485c4.874-.013 8.826 4.206 8.826
            9.397zm6.27-.245c-.06-.097-1.58-2.533-4.184-5.017-3.4-3.21-7.064-4.957-10.636-5.03H
            189.756c-.057 0-.126 0-.183.01h-.035c-2.328.124-5.843 1.157-10.13 5.02-2.74 2.46-4.48
            4.895-4.55 4.994l-.185.258.185.27c.07.1 1.75 2.535 4.46 4.995 3.513 3.21 7.13 4.932
            10.484 5.03h.497c.057 0 .115 0 .184-.012h.035c.298-.012.598-.05.897-.086.035 0
            .07-.012.115-.012h.035c2.224-.357 5.29-1.574 8.988-4.908 2.742-2.46 4.516-4.896
            4.585-4.994l.185-.246-.173-.27z"
        />
      </G>
    </Svg>
  );
}

InsightsIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

InsightsIcon.defaultProps = {
  height: 21,
  width: 32,
};

export default pure(InsightsIcon);
